import { render, staticRenderFns } from "./CCFileConfiguration.vue?vue&type=template&id=24d7147e"
import script from "./CCFileConfiguration.vue?vue&type=script&lang=js"
export * from "./CCFileConfiguration.vue?vue&type=script&lang=js"
import style0 from "./CCFileConfiguration.vue?vue&type=style&index=0&id=24d7147e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports